import { render, staticRenderFns } from "./resumeList.vue?vue&type=template&id=05931a4b&scoped=true&"
import script from "./resumeList.vue?vue&type=script&lang=js&"
export * from "./resumeList.vue?vue&type=script&lang=js&"
import style0 from "./resumeList.vue?vue&type=style&index=0&id=05931a4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05931a4b",
  null
  
)

export default component.exports